<div class="breadcrumbs">
	<div class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let i = index">
		<a [routerLink]="[breadcrumb.url]">{{breadcrumb.label}}</a>
	</div>	
</div>